var _style, _rect, _rect2, _rect3, _rect4, _path, _td, _path2, _path3, _td2, _path4, _td3, _path5, _path6, _td4, _path7, _path8, _td5, _path9, _td6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeforcesCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 290,
    viewBox: "0 0 380 290",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Harshit Sachan | Codeforces Stats") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  svg {\n    font-size: 14px;\n    line-height: 21px;\n  }\n\n  #background {\n    width: calc(100% - 1px);\n    height: calc(100% - 1px);\n    fill: #151515;\n    stroke: #e4e2e2;\n    stroke-width: 1;\n    rx: 4px;\n    ry: 4px;\n  }\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: auto;\n  }\n\n  th {\n    padding: 0.5em;\n    padding-top: 0;\n    padding-bottom: 10px;\n    padding-left: 4px;\n    color: #fff;\n    display:flex;\n    align-items: center;\n    font-size: 24px;\n    font-family: 'Segoe UI', Ubuntu, Sans-Serif;\n    font-weight: bold;\n  }\n\n  td {\n    margin-bottom: 16px;\n    margin-top: 8px;\n    padding: 0.3em;\n    padding-left: 0.15em;\n    font-size: 18px;\n    font-family: 'Segoe UI', Ubuntu, \"Helvetica Neue\", Sans-Serif;\n    font-weight: 600;\n    line-height: 18px;\n    color: #9f9f9f;\n  }\n\n  .stats-num{\n    text-align: right;\n  }\n\n  \n\n  .octicon {\n    fill: #79ff97;\n    margin-right: 1ch;\n    vertical-align: top;\n    scale: 1.3;\n    margin-right: 10px;\n  }\n\n  \n\n  .logo {\n    margin-right: 1ch;\n  }\n\n  \n\n  th, tr {\n    opacity: 0;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  th{\n    animation: fadeIn 0.5s ease-in-out forwards;\n  }\n\n  tr{\n    animation: fadeIn 0.3s ease-in-out forwards;\n  }\n\n  \n\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    id: "background"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 17,
    y: 17,
    width: 347,
    height: 257
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      transform: "translateX(0)"
    }
  }, /*#__PURE__*/React.createElement("th", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "logo",
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 7,
    height: 18.125,
    rx: 2,
    fill: "#FFC107"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 10.125,
    width: 7,
    height: 14,
    rx: 2,
    fill: "#F44336"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 7,
    height: 24.125,
    rx: 2,
    fill: "#2196F3"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      paddingLeft: 8
    },
    id: "name"
  }, "Harshit Sachan"))), /*#__PURE__*/React.createElement("tr", {
    style: {
      animationDelay: "200ms"
    }
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      paddingBottom: 20,
      whiteSpace: "nowrap",
      lineHeight: "1.2em"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "#0fdb0f",
      fontWeight: "bold"
    },
    id: "category"
  }, "Pupil"), " (max: ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: "#0fdb0f",
      fontWeight: "bold"
    },
    id: "max-category"
  }, "Pupil"), ")\n              ")))), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      animationDelay: "600ms"
    }
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "octicon bi bi-star",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"
  }))), "Contest Rating:\n              "), _td || (_td = /*#__PURE__*/React.createElement("td", {
    className: "stats-num",
    id: "rating"
  }, "1210"))), /*#__PURE__*/React.createElement("tr", {
    style: {
      animationDelay: "800ms"
    }
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "octicon bi bi-award",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193.684 1.365 1.086 1.072L12.387 6l.248 1.506-1.086 1.072-.684 1.365-1.51.229L8 10.874l-1.355-.702-1.51-.229-.684-1.365-1.086-1.072L3.614 6l-.25-1.506 1.087-1.072.684-1.365 1.51-.229L8 1.126l1.356.702 1.509.229z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"
  }))), "Max Rating:\n              "), _td2 || (_td2 = /*#__PURE__*/React.createElement("td", {
    className: "stats-num",
    id: "max-rating"
  }, "1330"))), /*#__PURE__*/React.createElement("tr", {
    style: {
      animationDelay: "1000ms"
    }
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-check2-all octicon",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2h-3c-0.011 0 -0.02 0.005 -0.03 0.006 -0.326 -0.562 -0.683 -0.872 -0.71 -0.893A0.501 0.501 0 0 0 10.443 1h-4.886a0.497 0.497 0 0 0 -0.317 0.114c-0.026 0.021 -0.385 0.331 -0.71 0.893C4.52 2.006 4.511 2 4.5 2H1.5a0.498 0.498 0 0 0 -0.497 0.555c0.17 1.53 1.284 4.469 4.257 4.888a12.252 12.252 0 0 0 1.155 1.401c0.024 0.025 0.056 0.039 0.084 0.059V10h-1a0.5 0.5 0 0 0 -0.5 0.5v1.5H4a0.5 0.5 0 0 0 -0.5 0.5v2a0.5 0.5 0 0 0 0.5 0.5h8a0.5 0.5 0 0 0 0.5 -0.5v-2a0.5 0.5 0 0 0 -0.5 -0.5h-1v-1.5a0.5 0.5 0 0 0 -0.5 -0.5h-1v-1.097c0.029 -0.019 0.06 -0.034 0.084 -0.059a12.315 12.315 0 0 0 1.155 -1.401c2.974 -0.418 4.088 -3.357 4.257 -4.888a0.498 0.498 0 0 0 -0.124 -0.389A0.495 0.495 0 0 0 14.5 2zM2.102 3h2.028c-0.058 0.227 -0.105 0.466 -0.121 0.732 -0.051 0.805 0.129 1.639 0.534 2.497C2.926 5.574 2.314 3.887 2.102 3zM11.5 14H4.5v-1h7v1zm-1.5 -2h-4v-1h4v1zm-2.5 -2v-1h1v1h-1zm1.505 -2h-2.01c-1.391 -1.51 -2.061 -2.917 -1.99 -4.184 0.053 -0.962 0.527 -1.576 0.752 -1.815h4.486c0.226 0.241 0.699 0.855 0.752 1.816 0.07 1.268 -0.599 2.675 -1.99 4.184zm2.455 -1.776c0.404 -0.856 0.583 -1.689 0.532 -2.494A3.913 3.913 0 0 0 11.871 3h2.023c-0.218 0.882 -0.839 2.568 -2.434 3.224z"
  }))), "Contests:\n              "), _td3 || (_td3 = /*#__PURE__*/React.createElement("td", {
    className: "stats-num",
    id: "contests"
  }, "20"))), /*#__PURE__*/React.createElement("tr", {
    style: {
      animationDelay: "1200ms"
    }
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-check2-all octicon",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z"
  }))), "Problems Solved:\n              "), _td4 || (_td4 = /*#__PURE__*/React.createElement("td", {
    className: "stats-num",
    id: "problems-solved"
  }, "167"))), /*#__PURE__*/React.createElement("tr", {
    style: {
      animationDelay: "1400ms"
    }
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-x-lg octicon",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.333 5.333a3.667 3.667 0 1 1 5.731 3.031 6.003 6.003 0 0 1 3.933 5.453.5.5 0 0 1-1 .03 5 5 0 0 0-9.995 0 .5.5 0 0 1-.999-.029 6.003 6.003 0 0 1 3.933-5.454 3.663 3.663 0 0 1-1.603-3.031zM6 2.667A2.667 2.667 0 1 0 6 8a2.667 2.667 0 0 0 0-5.333z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.527 5.333c-.099 0-.195.007-.289.02a.5.5 0 1 1-.141-.989 3.02 3.02 0 0 1 2.253 5.398 4.46 4.46 0 0 1 2.637 4.071.5.5 0 0 1-1 0 3.462 3.462 0 0 0-2.464-3.315l-.356-.107V9.294l.273-.139a2.02 2.02 0 0 0-.913-3.822z"
  }))), "Friends of:\n              "), _td5 || (_td5 = /*#__PURE__*/React.createElement("td", {
    className: "stats-num",
    id: "friend-of-count"
  }, "15"))), /*#__PURE__*/React.createElement("tr", {
    style: {
      animationDelay: "1600ms"
    }
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-ui-checks-grid octicon",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z"
  }))), "Contributions:\n              "), _td6 || (_td6 = /*#__PURE__*/React.createElement("td", {
    className: "stats-num",
    id: "contribution"
  }, "0"))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeforcesCard);
export default __webpack_public_path__ + "static/media/codeforces_card.471856d435f3076566cce0d1a12a2eac.svg";
export { ForwardRef as ReactComponent };